export const SET_SESSION = 'SESSIONS/SET_SESSION';
export const HANDLE_LOADING = 'SESSIONS/HANDLE_LOADING';
